
import React, { useState, useCallback, useEffect } from 'react';

import Drawer from 'devextreme-react/drawer';
import { Template } from 'devextreme-react/core/template';
import { ButtonTypes } from 'devextreme-react/button';
import { TreeViewTypes } from 'devextreme-react/tree-view';

import { useNavigate } from 'react-router';

import { AppHeader, SideNavigationMenu, AppFooter } from '../../components';
import { useScreenSize } from '../../utils/media-query';
import { useMenuPatch } from '../../utils/patches';


import './public-header.scss';
import { SideNavigationItem } from '../../components/library/side-navigation-menu/SideNavigationMenu';

const MenuOpenState = {
  Closed : 1,
  Opened : 2,
  TemporaryOpened : 3,
}



export const PublicHeader = ({ title, children }) => {
  const navigate = useNavigate();
  const { isXSmall, isLarge } = useScreenSize();
  const [patchCssClass, onMenuReady] = useMenuPatch();
  const [menuStatus, setMenuStatus] = useState(null);

  const getDefaultMenuOpenState = useCallback(() => isLarge ? MenuOpenState.Opened : MenuOpenState.Closed, [isLarge]);
  const getMenuOpenState = useCallback((status) => {
    if (status === null) {
      return getDefaultMenuOpenState();
    }

    return status;
  }, [getDefaultMenuOpenState]);

  const getMenuStatus = useCallback((status) => {
    return status === getDefaultMenuOpenState() ? null : status;
  }, [getDefaultMenuOpenState]);

  const changeMenuStatus = useCallback((reducerFn) => {
    setMenuStatus(prevMenuStatus => getMenuStatus(reducerFn(getMenuOpenState(prevMenuStatus)) ?? prevMenuStatus));
  }, [getMenuOpenState, getMenuStatus]);

  const toggleMenu = useCallback(({ event }) => {
    changeMenuStatus(prevStatus => prevStatus === MenuOpenState.Closed ? MenuOpenState.Opened : MenuOpenState.Closed);
    event?.stopPropagation();
  }, [changeMenuStatus]);

  const temporaryOpenMenu = useCallback(() => {
    changeMenuStatus(prevStatus => prevStatus === MenuOpenState.Closed ? MenuOpenState.TemporaryOpened : null);
  }, [changeMenuStatus]);

  const onOutsideClick = useCallback(() => {
    changeMenuStatus(prevStatus => prevStatus !== MenuOpenState.Closed && !isLarge ? MenuOpenState.Closed : null);
    return !isLarge;
  }, [isLarge, changeMenuStatus]);

  const onNavigationChanged = useCallback(
    ({ itemData: { path }, event, node }) => {
      if (getMenuOpenState(menuStatus) === MenuOpenState.Closed || !path || node?.selected) {
        event?.preventDefault();
        return;
      }

      navigate(path);
      if (!isLarge || menuStatus === MenuOpenState.TemporaryOpened) {
        setMenuStatus(getMenuStatus(MenuOpenState.Closed));
        event?.stopPropagation();
      }
    },
    [navigate, menuStatus, isLarge]
  );

  useEffect(() => {
    changeMenuStatus(() => menuStatus);
  }, [isLarge]);

  return (
    <div className='public-header'>
      <AppHeader menuToggleEnabled={false} className='layout-public-header' title={title} />
        <div className='content'>
          {React.Children.map(children, (item) => {
            return React.isValidElement(item) && item.type !== AppFooter && item;
          })}
        </div>
    </div>
  );
};
